import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getIsAuthenticated } from '@/redux/selectors/auth/user';
import { navigateTo } from '@/utility/navigateTo';
import { triggerLoginModal } from '@/utility/triggerLoginModal';

export const useHostingAutoFlow = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);

  const redirectToHostingAutoFlow = useCallback(() => {
    if (isAuthenticated) {
      navigateTo(`${process.env.hostApp}/list-your-auto`);
    } else {
      triggerLoginModal();
    }
  }, [isAuthenticated]);

  return { redirectToHostingAutoFlow, loading: false };
};
